
<template>
  <div class="admin-asignaturas-container">
    <CardPrime class="admin-asignaturas-card">
      <template #title>
        <div class="card-header">
          <h3 class="card-title">Administración de Asignaturas para Alumnos</h3>
        </div>
      </template>
      <template #content>
        <UserTable
          :usuarios="usuarios"
          :rows="lazyParams.rows"
          :totalRecords="totalRecords"
          :filters="filters"
          :loading="loading"
          @page="onPage"
          @update:filters="updateFilters"
          v-model:selectedUsuarios="selectedUsuarios"
        />
        <div v-if="selectedUsuarios.length > 0" class="mt-4">
          <!-- Sección para agregar asignaturas adicionales -->
          <div class="form-field mt-4">
            <label for="asignaturas-agregar" class="block text-sm font-medium text-gray-700">Agregar Asignatura</label>
            <AsignaturaDropdown
              :mostrarErrores="mostrarErroresAdicionales"
              :tooltip="'Selecciona la Asignatura a agregar'"
              :error="errorsAdicionales.nuevaAsignatura"
              :modelValue="nuevaAsignatura"
              @update:modelValue="nuevaAsignatura = $event"
            />
            <small v-if="mostrarErroresAdicionales && errorsAdicionales.nuevaAsignatura" class="p-error">{{ errorsAdicionales.nuevaAsignatura }}</small>
          </div>
          <ButtonPrime
            label="Agregar Asignatura Seleccionada"
            @click="openConfirmModalAdicionales"
            class="mt-2"
          />
        </div>
        <!-- Modal para agregar asignatura masiva -->
        <DialogPrime
          header="Confirmar Agregar Asignatura"
          v-model:visible="showConfirmModalAdicionales"
          :modal="true"
          :closable="false"
        >
          <p>
            ¿Estás seguro de agregar la asignatura seleccionada a {{ selectedUsuarios.length }} alumno(s)?
          </p>
          <div class="flex justify-end space-x-2">
            <ButtonPrime label="Confirmar" @click="confirmarAgregarAsignatura" />
            <ButtonPrime label="Cancelar" @click="closeConfirmModalAdicionales" class="p-button-secondary" />
          </div>
        </DialogPrime>
        <!-- Modal de progreso -->
        <DialogPrime
          header="Progreso de Actualización"
          v-model:visible="showProgressModal"
          :modal="true"
          :closable="false"
        >
          <p>Actualizando {{ currentProgress }} de {{ totalProgress }} alumnos...</p>
          <ProgressBar :value="progressPercentage" />
        </DialogPrime>
        <ToastPrime />
      </template>
    </CardPrime>
  </div>
</template>

<script>
import { FilterMatchMode } from 'primevue/api';
import usuarioService from '@/services/UsuarioService'; // Ajustar si es necesario para asignaturas
import CardPrime from 'primevue/card';
import ButtonPrime from 'primevue/button';
import DialogPrime from 'primevue/dialog';
import ToastPrime from 'primevue/toast';
import ProgressBar from 'primevue/progressbar';
import UserTable from '@/components/user/UserTable.vue'; // Asumiendo que se reutiliza, ajustar si es necesario
import AsignaturaDropdown from '@/components/selectores/AsignaturaDropdown.vue'; // Importa el componente proporcionado
import axios from 'axios';

export default {
  components: {
    CardPrime,
    ButtonPrime,
    DialogPrime,
    ToastPrime,
    ProgressBar,
    UserTable,
    AsignaturaDropdown // Registra el componente AsignaturaDropdown
  },
  data() {
    return {
      usuarios: [],
      totalRecords: 0,
      loading: false,
      filters: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        Email: { value: null, matchMode: FilterMatchMode.CONTAINS },
        colegio: '',
        curso: ''
      },
      lazyParams: {
        first: 0,
        rows: 20,
        page: 1
      },
      selectedUsuarios: [],
      nuevaAsignatura: null, // Valor único para una sola asignatura
      showConfirmModalAdicionales: false,
      showProgressModal: false,
      currentProgress: 0,
      totalProgress: 0,
      errorsAdicionales: {
        nuevaAsignatura: ''
      },
      mostrarErroresAdicionales: false
    };
  },
  methods: {
    async cargarUsuarios() {
      this.loading = true;
      try {
        const response = await usuarioService.getAlumnosPorCurso({
          IdColegio: this.filters.colegio || 0,
          IdCurso: this.filters.curso || 0,
          Page: this.lazyParams.page,
          Rows: this.lazyParams.rows
        });
        this.usuarios = response.data.items.map(usuario => ({
          ...usuario,
          Nombre: usuario.nombre,
          ApellidoPaterno: usuario.apellido_paterno,
          ApellidoMaterno: usuario.apellido_materno,
          IdentificadorRut: usuario.identificador_rut,
          Email: usuario.email,
          NombreCompleto: `${usuario.nombre || ''} ${usuario.apellido_paterno || ''}`.trim()
        }));
        this.totalRecords = response.data.totalRecords;
      } catch (error) {
        console.error('Error al cargar usuarios:', error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No se pudieron cargar los alumnos',
          life: 4000
        });
      } finally {
        this.loading = false;
      }
    },
    updateFilters(newFilters) {
      this.filters = {
        ...this.filters,
        colegio: newFilters.colegio,
        curso: newFilters.curso
      };
      this.lazyParams.page = 1;
      this.lazyParams.first = 0;
      this.cargarUsuarios();
    },
    onPage(event) {
      this.lazyParams = {
        ...this.lazyParams,
        first: event.first,
        rows: event.rows,
        page: Math.floor(event.first / event.rows) + 1
      };
      this.cargarUsuarios();
    },
    openConfirmModalAdicionales() {
      this.errorsAdicionales.nuevaAsignatura = !this.nuevaAsignatura ? 'Debes seleccionar una asignatura' : '';
      this.mostrarErroresAdicionales = true;
      if (this.errorsAdicionales.nuevaAsignatura) {
        return;
      }
      if (!this.selectedUsuarios.length) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Advertencia',
          detail: 'Selecciona al menos un alumno.',
          life: 3000
        });
        return;
      }
      this.mostrarErroresAdicionales = false;
      this.showConfirmModalAdicionales = true;
    },
    closeConfirmModalAdicionales() {
      this.showConfirmModalAdicionales = false;
    },
    async confirmarAgregarAsignatura() {
      this.closeConfirmModalAdicionales();
      this.showProgressModal = true;
      this.currentProgress = 0;
      this.totalProgress = this.selectedUsuarios.length;

      const token = localStorage.getItem('token');
      const promises = this.selectedUsuarios.map(async (usuario) => {
        try {
          // Aquí, para evitar duplicados, podrías agregar un check previo llamando a un endpoint que verifique si ya existe
          // Por ejemplo: await axios.get(`/api/check-asignatura/${usuario.id_usuario}/${this.nuevaAsignatura}`);
          // Si no existe, proceder con el post. Asumimos que el backend lo maneja (e.g., INSERT IF NOT EXISTS en SP)

          await axios.post('http://localhost:54494/api/v2/save/alumno/contrato-detalle/agregar-asignaturas', {
            IdUsuario: parseFloat(usuario.id_usuario),
            IdCurso: usuario.id_curso || 4,
            IdAsignatura: parseFloat(this.nuevaAsignatura),
            ValorNeto: 100000,
            PorcentajeIVA: 19,
            CantidadLicencias: 1,
            Vigente: true,
            IdUsuarioCreacion: 1,
            IdUsuarioActualizacion: 1
          }, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });
          this.currentProgress++;
        } catch (error) {
          console.error(`Error al agregar asignatura para usuario ${usuario.id_usuario}:`, error);
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: `Error al procesar usuario ${usuario.id_usuario}`,
            life: 3000
          });
        }
      });

      await Promise.all(promises);

      this.showProgressModal = false;
      this.$toast.add({
        severity: 'success',
        summary: 'Éxito',
        detail: 'Asignatura agregada exitosamente.',
        life: 3000
      });
      this.cargarUsuarios();
      this.selectedUsuarios = [];
      this.nuevaAsignatura = null;
    },
    get progressPercentage() {
      return (this.currentProgress / this.totalProgress) * 100;
    }
  },
  mounted() {
    this.cargarUsuarios();
  }
};
</script>

<style scoped>
.admin-asignaturas-container {
  padding: 1rem;
}
.admin-asignaturas-card {
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  padding: 1rem;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.card-title {
  font-size: 1.25rem;
  font-weight: bold;
  color: #1a202c;
}
.form-field {
  margin-bottom: 1rem;
}
.form-field label {
  display: block;
  font-size: 0.875rem;
  font-weight: medium;
  color: #4a5568;
  margin-bottom: 0.25rem;
}
</style>